let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f9Q6A")).then(() => parcelRequire('8worD'));